import { Link, LinkProps } from 'react-router-dom';

export default function LinkButtonHome({
  children,
  ...rest
}: LinkProps & React.RefAttributes<HTMLAnchorElement>) {
  return <Link {...rest}>{children}</Link>;
}
